(() => {
  const shortcutSelector = '[data-lotus-form-jump]';
  const mobileMedia = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initializeShortcut = (shortcut) => {
    if (shortcut.dataset.lotusFormJumpReady === 'true') return;

    const targetId = shortcut.getAttribute('href')?.replace(/^#/, '');
    const form = targetId ? document.getElementById(targetId) : null;
    if (!form) return;

    shortcut.dataset.lotusFormJumpReady = 'true';
    let formIsNear = false;

    const updateVisibility = () => {
      const showShortcut = mobileMedia.matches && !formIsNear;
      shortcut.classList.toggle('is-visible', showShortcut);
      shortcut.setAttribute('aria-hidden', showShortcut ? 'false' : 'true');
      shortcut.tabIndex = showShortcut ? 0 : -1;
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        formIsNear = entry.isIntersecting;
        updateVisibility();
      },
      { rootMargin: '20% 0px 20% 0px' }
    );

    observer.observe(form);
    mobileMedia.addEventListener('change', updateVisibility);

    shortcut.addEventListener('click', (event) => {
      event.preventDefault();

      shortcut.classList.remove('is-visible');
      shortcut.setAttribute('aria-hidden', 'true');
      shortcut.tabIndex = -1;

      const header = document.querySelector('#header-group');
      const headerBottom = header
        ? Array.from(header.children).reduce(
            (bottom, child) => Math.max(bottom, child.getBoundingClientRect().bottom),
            0
          )
        : 0;
      const targetTop = window.scrollY + form.getBoundingClientRect().top - headerBottom - 16;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    });

  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll(shortcutSelector).forEach(initializeShortcut);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
